<template>
  <div class="login-container">
    <div class="login-box">
      <h1 class="login-title">Administração</h1>

      <div v-if="mensagem" class="error">
        <span v-html="mensagem"></span>
      </div>

      <form @submit.prevent="tryLogin">
        <label for="email" class="login-label">E-mail</label>
        <input
          class="login-input"
          id="email"
          v-model="email"
          type="text"
          placeholder="exemplo@email.com.br"
        />

        <label for="senha" class="login-label">Senha</label>
        <input
          class="login-input"
          id="senha"
          v-model="senha"
          type="password"
          placeholder="senha"
        />

        <button class="login-button">Entrar</button>
      </form>
    </div>
  </div>
</template>

<script>
import adminService from "@/services/adminService.js";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      senha: "",
      mensagem: "",
      loading: false
    };
  },
  methods: {
    tryLogin() {
      if (this.loading) return;

      this.mensagem = "";
      this.loading = true;

      adminService
        .authenticate(this.email, this.senha)
        .then(res => {
          if (res.data.errors) {
            this.mensagem = res.data.errors.join("<br>");
          } else {
            localStorage.apiToken = res.data.token;
            this.$router.push({ name: "inicio" });
          }
        })
        .catch(err => {
          this.mensagem =
            "Ocorreu um desconhecido ao fazer o login\n" + err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style>
.login-container {
  height: 100vh;
  width: 100vw;
  background: #34495e;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-box {
  padding: 25px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  width: 350px;
}

.login-title {
  font-size: 1.2em;
  text-align: center;
  font-weight: normal;
  margin: 20px 0 40px 0;
}

.login-input {
  border: none;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 15px;
  margin-bottom: 15px;
  background: #f5f5f5;
  font-size: 0.8em;
}

.login-label {
  display: block;
  margin-bottom: 10px;
  font-size: 0.9em;
}

.login-button {
  width: 100%;
  padding: 10px;
  background: #2c3e50;
  color: #fff;
  margin-top: 20px;
  font-size: 0.8em;
}

.login-button:enabled {
  cursor: pointer;
}

.login-button:hover:enabled,
.login-button:focus:enabled {
  background: #1d2d3e;
}

.login-button:disabled {
  background: #b9b9b9;
}

.error {
  background: #f44336;
  color: #fff;
  padding: 10px;
  font-size: 0.8em;
  border-radius: 3px;
  margin-bottom: 20px;
}
</style>
